<template>
  <v-overlay v-model="show" style="z-index:6">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      show: "overlayLoading"
    })
  }
};
</script>
